import { Link } from "react-router-dom"
import './ErrorPage.scss'

export default function EroorPage(){

    return(
        <div className="ErrorPage">
            <img src="./oops.svg" alt="oops" />
            <h1>Ой... Здається цієї сторінки не існує</h1>
            <p>Але не хвилюйтесь, ви можете повернутись на головну</p>
            <Link to="/">На головну</Link>
        </div>
    )
}